// en, de, fr, pt
import i18nBuyer from './vi/i18nBuyer';
import i18nCommon from './vi/i18nCommon';
import i18nComponent from './vi/i18nComponent';
import i18nDashboard from './vi/i18nDashboard';
import i18nDateRange from './vi/i18nDateRange';
import i18nDeclarationSubmit from './vi/i18nDeclarationSubmit';
import i18nEnum from './vi/i18nEnum';
import i18nLogin from './vi/i18nLogin';
import i18nNavbar from './vi/i18nNavbar';
import i18nNotification from './vi/i18nNotification';
import i18nResources from './vi/i18nResources';
import i18nServiceTVAN from './vi/i18nServiceTVAN';
import i18nShortkey from './vi/i18nShortkey';
import i18nSlidebar from './vi/i18nSlidebar';
import i18nTaxPaper from './vi/i18nTaxPaper';
import i18nTaxPayment from './vi/i18nTaxPayment';
import i18nTaxRegister from './vi/i18nTaxRegister';
import i18nUserManager from './vi/i18nUserManager';
import i18nValidate from './vi/i18nValidate';
import i18nTaxPayer from './vi/i18nTaxPayer'
import i18nSystem from './vi/i18nSystem'
import i18nTaxDec from './vi/i18nTaxDec';
import i18nStarted from './vi/i18nStarted';
import i18nHelpPath from './vi/i18nHelpPath'
import i18nReport from './vi/i18nReport'
import i18nStateBudget from './vi/i18nStateBudget';
import i18nActiveStore from './vi/i18nActiveStore';
import i18nAmisConvert from './vi/i18nAmisConvert';
import i18nRemoteSigning from './vi/i18nRemoteSigning';

export default {
    vi: {
        i18nBuyer,
        i18nCommon,
        i18nComponent,
        i18nDashboard,
        i18nDateRange,
        i18nDeclarationSubmit,
        i18nEnum,
        i18nLogin,
        i18nNavbar,
        i18nNotification,
        i18nResources,
        i18nServiceTVAN,
        i18nShortkey,
        i18nSlidebar,
        i18nTaxPayment,
        i18nTaxRegister,
        i18nUserManager,
        i18nValidate,
        i18nTaxPaper,
        i18nTaxPayer,
        i18nSystem,
        i18nTaxDec,
        i18nStarted,
        i18nHelpPath,
        i18nStateBudget,
        i18nReport,
        i18nActiveStore,
        i18nAmisConvert,
        i18nRemoteSigning
    }
};